<template>
  <label class="products-filter-field multiple-store">
    <span><b-icon icon="shop"></b-icon> فروشگاه</span>
    <select @change="selectedStoreChange" class="products-filter-input" v-model="selectedStore">
      <option value="">همه</option>
      <option v-for="store in stores" :key="store.id" :value="store.id">{{ store.name }}</option>
    </select>
  </label>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "MultipleStore",
  data() {
    return {
      selectedStore: '',
    }
  },
  computed: {
    ...mapGetters({
      stores: 'MultipleStore/getStores'
    })
  },
  methods: {
    setFilters(value, from = 'router') {
      const routeName = this.$route.name;
      if (routeName === 'Orders') {
        this.$store.commit('ShoppingCart/setFilters', {key: 'multiple_store', value: [value]})
        if (from !== 'router') {
          this.$store.dispatch("ShoppingCart/getAllOrders")
        }
      }
      if (routeName === 'ProductsDashboard') {
        this.$store.commit("Product/setFilters", {key: "multiple_store", value: [value]});
        if (from !== 'router') {
          this.$store.dispatch("Product/setDashboardProducts")
        }
      }
    },
    selectedStoreChange(event) {
      this.selectedStore = event.target.value;
      this.setFilters(this.selectedStore, 'change')
      this.$emit('updateFilter', {multiple_store: this.selectedStore})
    }
  },
  mounted() {
    let value = this.$route.query.multiple_store;
    if (value != undefined) {
      this.selectedStore = value
      this.setFilters(value)
    }

    this.$store.dispatch('MultipleStore/getStores')
  },
  destroyed() {
    this.$store.commit("Product/setFilters", {key: "multiple_store", value: []});
    this.$store.commit('ShoppingCart/setFilters', {key: 'multiple_store', value: []})
  }
}
</script>

<style scoped>
.multiple-store {
  overflow: visible;
  height: auto;
  display: block;
  margin: 0;
}

.multiple-store span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: #6b7280;
  margin-bottom: 4px;
  font-weight: 700;
}

.multiple-store .products-filter-input {
  width: 100%;
}
</style>